export type SceneInteractionMode = 'navigate' | 'move-node';

export interface ResolveSceneInteractionModeOptions {
	readonlyMode?: boolean;
}

export const DEFAULT_SCENE_INTERACTION_MODE: SceneInteractionMode = 'navigate';

export function isSceneInteractionMode(value: unknown): value is SceneInteractionMode {
	return value === 'navigate' || value === 'move-node';
}

export function normalizeSceneInteractionMode(value: unknown): SceneInteractionMode {
	return isSceneInteractionMode(value) ? value : DEFAULT_SCENE_INTERACTION_MODE;
}

export function resolveSceneInteractionMode(
	requestedMode: unknown,
	options: ResolveSceneInteractionModeOptions = {},
): SceneInteractionMode {
	const normalizedMode = normalizeSceneInteractionMode(requestedMode);

	if (options.readonlyMode && normalizedMode === 'move-node') {
		return DEFAULT_SCENE_INTERACTION_MODE;
	}

	return normalizedMode;
}

export function canEnterMoveNodeMode(readonlyMode: boolean): boolean {
	return !readonlyMode;
}